// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__NQ3oC","col":"styles_col__1NJma"};